import React from 'react';
import { motion } from 'framer-motion';
import { Award, Quote, Shield, Trophy, ExternalLink } from 'lucide-react';
import { professionalImpact } from '../data/siteData';

const Impact = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const hasImpact = professionalImpact && professionalImpact.length > 0;

  const getTypeIcon = (type) => {
    switch (type) {
      case 'certification':
        return Shield;
      case 'award':
        return Trophy;
      case 'recommendation':
        return Quote;
      default:
        return Award;
    }
  };

  return (
    <section id="impact" className="impact-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1>Professional Impact</h1>
          <p>Verified Achievements, Recommendations & Results</p>
        </motion.div>

        {hasImpact ? (
          <motion.div
            className="impact-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {professionalImpact.map((item) => {
              const TypeIcon = getTypeIcon(item.type);
              return (
                <motion.div
                  key={item.id}
                  className="impact-card"
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                >
                  <div className="impact-icon">
                    <TypeIcon size={24} />
                  </div>
                  <div className="impact-content">
                    <span className="impact-type">{item.type}</span>
                    <h2>{item.title}</h2>
                    {item.source && <p className="impact-source">{item.source}</p>}
                    <p className="impact-description">{item.description}</p>
                    {item.url && (
                      <a 
                        href={item.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="impact-link"
                      >
                        Verify <ExternalLink size={14} />
                      </a>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        ) : (
          <motion.div
            className="empty-state"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <Award size={48} className="empty-state-icon" />
            <p className="empty-state-text">Professional impact coming soon</p>
            <p className="empty-state-subtext">Achievements, certifications, and recommendations will appear here.</p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Impact;
